import { useActions, useState } from '@/utils/map-state';
import { promoteUrl } from "@/utils/url";
export default {
  name: "loginBoxPC",
  setup() {
    const commonState = useState('common', ['loginBox']);
    let {
      loginBox
    } = commonState;
    const commonActions = useActions('common', ['clearLoginBox']);
    const close = () => {
      commonActions.clearLoginBox({});
    };
    const gotoLogin = method => {
      window.location.href = promoteUrl() + '/member_vue.php?platform=1&method=' + (method === 'reg' ? method : 'login');
    };
    const buttonMethodText = method => {
      return method === 'reg' ? '注册' : '登录';
    };
    return {
      buttonMethodText,
      gotoLogin,
      loginBox,
      close
    };
  }
};